import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ActivityACHPage, { getDefaultData } from "components/pages/ActivityACHPage";
import Classes from "model";

/**
 * @function CaptureACHApprovalsActivityChecked
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description Component in the MABI23 "Approvals" capture group.
 */
export default function CaptureACHApprovalsActivityChecked() {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const achBatches = getDefaultData()
    .pendingSameDayACHBatchesWidgetData.achBatches
    .map(item => {
        item.selected = true;
        return item;
    });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "pendingSameDayACHBatchesWidgetData", "achBatches" ], achBatches)
    .submit();

    return <ActivityACHPage data={ data } />
}